/* ==========================================================
   Unisource Product Catalog Card Click Area Fix
   - Makes the product card body/light-yellow hover area clickable
   - Keeps swatches, + more colors, and Compare independently clickable
   - Does not replace poc-demo-render.js
========================================================== */

(function () {
  "use strict";

  function clean(value) {
    return String(value || "").trim();
  }

  function getProductId(card) {
    if (!card) return "";

    return clean(
      card.getAttribute("data-product-id") ||
      card.getAttribute("data-id") ||
      card.dataset.productId ||
      ""
    );
  }

  function getActiveSwatch(card) {
    if (!card) return null;

    return (
      card.querySelector(".poc-demo-card__swatch.is-active") ||
      card.querySelector(".poc-demo-card__swatch[aria-pressed='true']") ||
      card.querySelector("[data-card-swatch].is-active") ||
      card.querySelector("[data-card-swatch][aria-pressed='true']")
    );
  }

  function getSwatchStyleId(swatch) {
    if (!swatch) return "";

    return clean(
      swatch.getAttribute("data-style-id") ||
      swatch.getAttribute("data-styleid") ||
      swatch.getAttribute("data-product-style-id") ||
      swatch.getAttribute("data-card-swatch-style-id") ||
      swatch.dataset.styleId ||
      swatch.dataset.styleid ||
      ""
    );
  }

  function getSwatchColorName(swatch) {
    if (!swatch) return "";

    return clean(
      swatch.getAttribute("data-color-name") ||
      swatch.getAttribute("data-color") ||
      swatch.getAttribute("data-option-name") ||
      swatch.getAttribute("data-value") ||
      swatch.getAttribute("aria-label") ||
      swatch.getAttribute("title") ||
      ""
    );
  }

  function getExistingProductUrl(card) {
    if (!card) return "";

    var selectors = [
      ".poc-demo-card__thumb-link",
      ".poc-demo-card__title-link",
      "a[href*='/pages/inksoft-product']"
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var link = card.querySelector(selectors[i]);
      var href = link ? clean(link.getAttribute("href")) : "";
      if (href) return href;
    }

    return clean(
      card.getAttribute("data-current-product-url") ||
      card.getAttribute("data-product-url") ||
      ""
    );
  }

  function buildProductUrl(card) {
    var existingUrl = getExistingProductUrl(card);
    var productId = getProductId(card);

    var url;

    try {
      if (existingUrl) {
        url = new URL(existingUrl, window.location.origin);
      } else {
        url = new URL("/pages/inksoft-product", window.location.origin);
      }

      if (productId && !url.searchParams.get("id")) {
        url.searchParams.set("id", productId);
      }

      var swatch = getActiveSwatch(card);
      var styleId = getSwatchStyleId(swatch);
      var colorName = getSwatchColorName(swatch);

      if (styleId) {
        url.searchParams.set("styleId", styleId);
      }

      if (colorName) {
        url.searchParams.set("selectedColor", colorName);
      }

      return url.toString();
    } catch (_error) {
      if (existingUrl) return existingUrl;
      return productId ? ("/pages/inksoft-product?id=" + encodeURIComponent(productId)) : "";
    }
  }

  function isCardInteractiveClick(event) {
    var target = event.target;
    if (!target || !target.closest) return false;

    /*
      These must keep their own behavior:
      - color swatches update the card image
      - + more colors opens detail
      - Compare button remains Compare
      - any real anchor/button/input remains independent
    */
    return !!target.closest([
      ".poc-demo-card__swatch",
      ".poc-demo-card__swatches-more",
      "[data-card-swatch]",
      "[data-swatch-more]",
      "[data-compare-toggle]",
      ".poc-demo-card__actions",
      ".poc-demo-action-button",
      "button",
      "a",
      "input",
      "select",
      "textarea",
      "label"
    ].join(","));
  }

  function markCards() {
    var cards = document.querySelectorAll(".poc-demo-card[data-product-id]");
    Array.prototype.forEach.call(cards, function (card) {
      card.classList.add("unisource-card-click-area");
      card.setAttribute("role", "link");

      if (!card.hasAttribute("tabindex")) {
        card.setAttribute("tabindex", "0");
      }
    });
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var card = target.closest(".poc-demo-card[data-product-id]");
    if (!card) return;

    if (isCardInteractiveClick(event)) return;

    var url = buildProductUrl(card);
    if (!url) return;

    window.location.href = url;
  }

  function handleKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;

    var target = event.target;
    if (!target || !target.closest) return;

    var card = target.closest(".poc-demo-card[data-product-id]");
    if (!card || target !== card) return;

    var url = buildProductUrl(card);
    if (!url) return;

    event.preventDefault();
    window.location.href = url;
  }

  function observeCards() {
    markCards();

    var grid =
      document.getElementById("poc-demo-products-grid") ||
      document.querySelector(".poc-demo-grid");

    if (!grid || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      markCards();
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener("click", handleClick, true);
  document.addEventListener("keydown", handleKeydown, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeCards);
  } else {
    observeCards();
  }

  window.addEventListener("load", markCards);
})();
